/**
 * Which Azure Storage refusals a PERMISSION fixes (Codex merge-C review C-M01 / C-M02). Azure names the cause of a 403
 * in its error code (Microsoft Learn, "Shared access signature error codes", "Prevent authorization with Shared Key"):
 *
 * - `AuthorizationPermissionMismatch` — the SAS's permissions (`sp`), or, for Microsoft Entra ID, no role granting the
 *   action — and `AuthorizationResourceTypeMismatch` — an account SAS's resource types (`srt`) — are fixed by granting
 *   more: these, and only these, are permission refusals.
 * - `AuthorizationSourceIPMismatch` (the SAS's allowed IP range), `AuthorizationProtocolMismatch` (an HTTPS-only SAS
 *   sent over HTTP), `KeyBasedAuthenticationNotPermitted` (the account disallows Shared Key, so its key and every SAS
 *   signed with it are refused whatever they grant), `AuthorizationServiceMismatch` (a SAS without the service) and
 *   `AuthorizationFailure` (a firewall / network rule, disabled public network access, a role condition — and, on real
 *   Azure, a SAS outside its IP range: checked 2026-09-27) are not.
 *
 * A 403 without a code (a response that carried no `x-ms-error-code`) cannot be told apart and keeps counting as a
 * permission refusal. Shared renderer <-> main: Test Connection's probe context (`electron/azure-storage/probeContext.ts`)
 * and table administration in both processes (`tables/tableAdminErrors.ts`, `entities/model/tableAdminRefusals.ts`).
 */
export const STORAGE_PERMISSION_CODES: ReadonlySet<string> = new Set(['AuthorizationPermissionMismatch', 'AuthorizationResourceTypeMismatch']);

export function isStoragePermissionRefusal(error: { category: string; code?: string; status?: number }): boolean {
  if (error.category !== 'authorization') return false;
  return error.code === undefined ? error.status === 403 : STORAGE_PERMISSION_CODES.has(error.code);
}
